export default {
    topics: [
        {
            title: ' CompleteURLParams ',
            href: 'sm-webForm-CompleteURLParams.html',
            attributes: { 'data-id': 'sm-webForm-CompleteURLParams' },
            menu: { hasChildren: false },
            tocID: 'sm-webForm-CompleteURLParams-d66e4225',
            topics: [],
        },
        {
            title: ' GenerateForm ',
            href: 'sm-webForm-GenerateForm.html',
            attributes: { 'data-id': 'sm-webForm-GenerateForm' },
            menu: { hasChildren: false },
            tocID: 'sm-webForm-GenerateForm-d66e4233',
            topics: [],
        },
        {
            title: ' GetFormInfo ',
            href: 'sm-webForm-GetFormInfo.html',
            attributes: { 'data-id': 'sm-webForm-GetFormInfo' },
            menu: { hasChildren: false },
            tocID: 'sm-webForm-GetFormInfo-d66e4241',
            topics: [],
        },
        {
            title: ' GetRcpIdFromConnectionString ',
            href: 'sm-webForm-GetRcpIdFromConnectionString.html',
            attributes: { 'data-id': 'sm-webForm-GetRcpIdFromConnectionString' },
            menu: { hasChildren: false },
            tocID: 'sm-webForm-GetRcpIdFromConnectionString-d66e4249',
            topics: [],
        },
        {
            title: ' ValidateForm ',
            href: 'sm-webForm-ValidateForm.html',
            attributes: { 'data-id': 'sm-webForm-ValidateForm' },
            menu: { hasChildren: false },
            tocID: 'sm-webForm-ValidateForm-d66e4257',
            topics: [],
        },
    ],
};

